import { render, staticRenderFns } from "./SpawnCard.vue?vue&type=template&id=9dfade9e"
import script from "./SpawnCard.vue?vue&type=script&lang=js"
export * from "./SpawnCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports